import * as React from "react";

import { ErrorPage } from "./ErrorPage";
import { trackStructuredEvent, trackUiErrorVertical } from "shared/src/utils/TrackingUtil";
import { isFixedContentWidth } from "../../searchdiscover/toggles";
import { Grid } from "react-bootstrap";

type PageWrapperContentProps = {
    children?: React.ReactNode;
    vertical: string;
    fullWidth?: boolean;
};

type State = {
    errorOccurred: boolean;
};

class PageWrapperContent extends React.Component<PageWrapperContentProps, State> {
    constructor(props: PageWrapperContentProps) {
        super(props);
        this.state = { errorOccurred: false };
    }
    componentDidCatch(
        error: Error,
        errorInfo: {
            componentStack: string;
        }
    ) {
        trackUiErrorVertical(this.props.vertical, errorInfo.componentStack, error.message, error);
        trackStructuredEvent("client.errorpage.display", {
            tags: {
                url: window.location.pathname
            }
        });
        this.setState({ errorOccurred: true });
    }
    render() {
        if (this.state.errorOccurred) {
            // TODO: This component is never being used.
            return <ErrorPage />;
        }
        return isFixedContentWidth() && !this.props.fullWidth ? (
            <div className="fixed-width-container">
                <Grid fluid>{this.props.children}</Grid>
            </div>
        ) : (
            <React.Fragment>{this.props.children}</React.Fragment>
        );
    }
}

export default PageWrapperContent;
